"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var Card = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "Card",
  componentId: "sc-1t58wkt-0"
})(["border-radius:4px;"]);
Card.propTypes = (0, _extends2["default"])({}, _Flex["default"].propTypes, {
  hasBorder: _propTypes["default"].bool,
  elevation: _propTypes["default"].number
});
Card.defaultProps = (0, _extends2["default"])({}, _Flex["default"].defaultProps, {
  flexDirection: "column",
  elevation: 2
});
var _default = Card;
exports["default"] = _default;